import {useAccessToken} from "../../services/auth"
import React, {useCallback, useEffect, useState} from "react"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useToasts} from "react-toast-notifications"
import {AppConfig, updateAppConfig} from "../../resources/whiteLabel"
import CallbacksFields from "../../components/Callbacks/CallbacksFields"
import Button from "../../components/Button/Button"
export default function Callbacks({appConfig, refresh}: {appConfig: AppConfig; refresh: () => void}) {
	const accessToken = useAccessToken()
	const [state, patch] = useAsyncResultIdle(updateAppConfig)
	const [endUserConfigUrl, setEndUserConfigUrl] = useState<string>(appConfig?.attributes?.endUserConfigUrl ?? "")
	const [findEndUsersUrl, setFindEndUsersUrl] = useState<string>(appConfig?.attributes?.findEndUsersUrl ?? "")
	const [bankingPageUrl, setBankingPageUrl] = useState<string>(appConfig?.attributes?.bankingPageURL ?? "")
	const {addToast} = useToasts()

	useEffect(() => {
		if (state.isOk()) {
			addToast("Org Settings Updated Successfully", {appearance: "success"})
			refresh()
		}
	}, [state])

	const updateField = useCallback((fieldName: string, value: string) => {
		switch (fieldName) {
			case "endUserConfigUrl":
				setEndUserConfigUrl(value)
				break
			case "findEndUsersUrl":
				setFindEndUsersUrl(value)
				break
			case "bankingPageUrl":
				setBankingPageUrl(value)
				break
		}
	}, [])

	const getCallbacksField = useCallback(() => {
		return (
			<CallbacksFields
				endUserConfigUrl={endUserConfigUrl}
				findEndUsersUrl={findEndUsersUrl}
				bankingPageUrl={bankingPageUrl}
				updateSettings={updateField}
			/>
		)
	}, [endUserConfigUrl, findEndUsersUrl, bankingPageUrl])

	return (
		<div className="card managed-solutions-settings-card">
			<div className={"callbacks-content card-content"}>
				<div className="description">
					The callback endpoints allow you to feed Unit additional information you have about the customer (such as KYB
					information, other end users associated with the customer) in order to streamline and add context to their
					banking experience.
				</div>
				<form
					onSubmit={(e) => {
						e.preventDefault()
						patch(accessToken, {
							endUserConfigUrl,
							findEndUsersUrl,
							bankingPageURL: bankingPageUrl,
						})
					}}
				>
					{getCallbacksField()}
					<div className="columns">
						<div className="column mt-4 button-container">
							{state.match(
								() => (
									<Button className="button primary" type="submit" prefixIcon="approve-v-check-validation">
										Save
									</Button>
								),
								() => (
									<Button className="button primary is-loading">Saving</Button>
								),
								(_) => null,
								(err) => (
									<>
										<div className="has-text-danger">{err.errors[0].title}</div>
										<Button className="button primary" type="submit" prefixIcon="approve-v-check-validation">
											Save
										</Button>
									</>
								)
							)}
						</div>
					</div>
				</form>
			</div>
		</div>
	)
}
